/**
 * @generated SignedSource<<1450eabc2dd0e84483ac4599e0a5d469>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type VideoFileStatus = "ERROR" | "PROCESSING" | "READY" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type courseVideo$data = {
  readonly video: {
    readonly __typename: "ExternalVideo";
    readonly url: string;
  } | {
    readonly __typename: "VideoFile";
    readonly id: string;
    readonly muxId: string | null | undefined;
    readonly playback: {
      readonly playback: string;
      readonly tokens: {
        readonly playback: string | null | undefined;
        readonly storyboard: string | null | undefined;
        readonly thumbnail: string | null | undefined;
      } | null | undefined;
    } | null | undefined;
    readonly rawID: string;
    readonly status: VideoFileStatus;
    readonly thumbnail: {
      readonly signedUrl: string;
    } | null | undefined;
    readonly url: string;
    readonly " $fragmentSpreads": FragmentRefs<"courseVideo_video">;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null | undefined;
  readonly " $fragmentType": "courseVideo";
};
export type courseVideo$key = {
  readonly " $data"?: courseVideo$data;
  readonly " $fragmentSpreads": FragmentRefs<"courseVideo">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "playback",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "courseVideo",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "video",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            (v0/*: any*/)
          ],
          "type": "ExternalVideo",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "id",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "rawID",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "muxId",
              "storageKey": null
            },
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "status",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "ImageFile",
              "kind": "LinkedField",
              "name": "thumbnail",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "signedUrl",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "VideoPlayback",
              "kind": "LinkedField",
              "name": "playback",
              "plural": false,
              "selections": [
                (v1/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "VideoFileTokens",
                  "kind": "LinkedField",
                  "name": "tokens",
                  "plural": false,
                  "selections": [
                    (v1/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "storyboard",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "thumbnail",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "courseVideo_video"
            }
          ],
          "type": "VideoFile",
          "abstractKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__typename",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "CourseContent",
  "abstractKey": null
};
})();

(node as any).hash = "9c4804efb762585fe91c8f6d3e71185c";

export default node;
